import { FC, ReactNode, createContext, useContext, useState } from "react";
import { useDispatch } from "react-redux";

import { logout } from "../store/slices/userSlice";

interface AuthContextType {
  handleLogout: () => void;
  isAuthenticated: boolean;
  login: () => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
  const token = localStorage.getItem("accessToken");
  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  const dispatch = useDispatch();

  const handleLogout = () => {
    setIsAuthenticated(false);
    dispatch(logout());
  };
  const login = () => {
    setIsAuthenticated(true);
  };

  return (
    <AuthContext.Provider value={{ handleLogout, isAuthenticated, login }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
